/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Search_Groups_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search event groups" |
*
* @param {Team_Share_Search_Groups_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_search_groups_placeholder = /** @type {((inputs?: Team_Share_Search_Groups_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Search_Groups_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "de") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "it") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "es") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Search event groups")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Search event groups")
	return /** @type {LocalizedString} */ ("Search event groups")
});